module.exports = __webpack_public_path__ + "img/144.once_a_year.a428246e.svg";